import { render, staticRenderFns } from "./UpdateUserInviteInfoDialog.vue?vue&type=template&id=4e10c5f6&scoped=true&lang=pug&"
import script from "./UpdateUserInviteInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdateUserInviteInfoDialog.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateUserInviteInfoDialog.vue?vue&type=style&index=0&id=4e10c5f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e10c5f6",
  null
  
)

export default component.exports